/* globals ga, pageReadyAt, MojoUser, INITIAL_STATE */
import { getUrlParameterByName } from 'config/utils';
import Analytics from 'config/Analytics';
import transactionCategoryConstants from './transactionCategoryConstants';

const pathnameArray = location.pathname.split('/');

function getSellerUsername () {
  const username = pathnameArray[1];
  if (!username) {
    return null;
  }

  if (username.charAt(0) === '@') {
    return username.replace('@', '');
  }

  return username;
}

const parentRefStoreFlag = getUrlParameterByName('ref'),
  intent = getUrlParameterByName('intent'),
  embed = getUrlParameterByName('embed'),
  signature = getUrlParameterByName('data_sign'),
  selfFlag = getSellerUsername().toLowerCase() === MojoUser.username,
  remoteCheckoutFlag = getUrlParameterByName('checkout'),
  discountCode = getUrlParameterByName('discount'),
  isLinkPayment = INITIAL_STATE.is_link_payment,
  isInstapayPayment = INITIAL_STATE.is_instapay_payment,
  isRAPPayment = INITIAL_STATE.is_rap;

function getTransactionCategory () {
  const paymentsTab = INITIAL_STATE.show_payment_tab;
  const socialpayTab = INITIAL_STATE.show_socialpay_tab;

  if (!paymentsTab && !socialpayTab) {
    return transactionCategoryConstants.Free;
  }
  else if (socialpayTab) {
    return transactionCategoryConstants.Social;
  }
  return transactionCategoryConstants.INR;
}

const track = () => {
  ga((tracker) => {
    try {
      const paymentReadyAt = (new Date()).getTime();
      const paymentLoadTime = (paymentReadyAt - pageReadyAt) / 1000;

      Analytics.sendEvent('Viewed Offer Page', {
        'seller_username': getSellerUsername(),
        'offer_id': pathnameArray[2] || null,
        'parent_ref_store_flag': parentRefStoreFlag,
        'ga_client_id': tracker.get('clientId'),
        'remote_checkout_flag': remoteCheckoutFlag,
        'intent': intent,
        'embed': embed,
        'self_flag': selfFlag,
        'discount_id': discountCode,
        'payment_signature_flag': !!signature,
        'transaction_category': getTransactionCategory(),
        'payment_form_load_time': paymentLoadTime,
        'link_flag': isLinkPayment || isInstapayPayment,
        'link_mode': isLinkPayment ? 'custom' : isRAPPayment ? 'rap' : isInstapayPayment ? 'default' : null,
        'link_id': isLinkPayment ? pathnameArray[2] : null,
      });
    } catch (e) {}
  });
};

export const trackClickedPaymentButton = ({ label }) => {
  try {
    Analytics.sendEvent('Clicked on Offer', {
      'seller_username': getSellerUsername(),
      'offer_id': pathnameArray[2] || null,
      button_id: label,
      'parent_ref_store_flag': parentRefStoreFlag,
      'remote_checkout_flag': remoteCheckoutFlag,
      'intent': intent,
      'embed': embed,
      'self_flag': selfFlag,
      'discount_id': discountCode,
      'payment_signature_flag': !!signature,
      'transaction_category': getTransactionCategory(),
      'link_flag': isLinkPayment || isInstapayPayment,
      'link_mode': isLinkPayment ? 'custom' : isRAPPayment ? 'rap' : isInstapayPayment ? 'default' : null,
      'link_id': isLinkPayment ? pathnameArray[2] : null,
    });
  } catch (e) {}
};

export default track;



// WEBPACK FOOTER //
// ./src/common/analytics/track.js